import React from 'react';
const ProfileEfficacyWidget = () => {
  // Profile efficacy score
  const score = 87;
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full p-6" data-id="element-610">
      <div className="flex flex-col h-full" data-id="element-611">
        <h2 className="text-base font-semibold text-gray-800 mb-6" data-id="element-612">
          Efficacia Profilo
        </h2>
        <div className="flex flex-col" data-id="element-613">
          <div className="flex items-baseline justify-between mb-2" data-id="element-614">
            <div className="text-lg font-medium text-gray-800" data-id="element-615">{score}%</div>
            <div className="text-sm text-gray-600" data-id="element-616">score efficacia</div>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-6" data-id="element-617">
            <div className="bg-custom-green h-2 rounded-full" style={{
            width: `${score}%`
          }} data-id="element-618"></div>
          </div>
          <div className="space-y-4" data-id="element-619">
            <div className="flex justify-between items-center" data-id="element-620">
              <span className="text-sm text-gray-600" data-id="element-621">Competenze</span>
              <span className="text-sm font-medium text-gray-800" data-id="element-622">92%</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-623">
              <span className="text-sm text-gray-600" data-id="element-624">Connessioni</span>
              <span className="text-sm font-medium text-gray-800" data-id="element-625">85%</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-626">
              <span className="text-sm text-gray-600" data-id="element-627">Attività</span>
              <span className="text-sm font-medium text-gray-800" data-id="element-628">84%</span>
            </div>
          </div>
        </div>
        <div className="mt-auto pt-6 text-sm text-gray-500" data-id="element-629">
          Benchmark profili simili: 72%
        </div>
      </div>
    </div>;
};
export default ProfileEfficacyWidget;